export function PageVignette() {
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none fixed inset-0 z-8 bg-[radial-gradient(ellipse_at_center,transparent_40%,rgba(0,0,0,0.55)_100%)]"
    />
  )
}
